import service from "Utility/Service";
import { QueryCache, useQueryClient, useMutation, useQuery } from "react-query";
import { AxiosRequestConfig } from "axios";
import React from "react";
import goSlice from "./goSlice";

const getTicketDetails = async (ticket: string) => {
  const config: AxiosRequestConfig = {
    method: "post",
    url: "/go",
    data: {
      status: {
        ticket: `${ticket}`,
      },
    },
  };

  const { data } = await service(config);
  return data;
};

export const useGetTicketDetails = (ticket: any) => {
  return useQuery("get-ticket-detail", () => getTicketDetails(ticket), {
    // placeholderData is not persisted to the cache，為了不讓 /go? 剛開始抓資料時顯示 404
    placeholderData: "",
    refetchInterval: 20000, // 每 5 秒更新一次
    // refetchIntervalInBackground: true, // 背景更新
  });
};
//////////////////////////////////////////////////////////////////////////////////

const updateDeviceData = async (props: any) => {
  const { values } = props;

  const config: AxiosRequestConfig = {
    method: "post",
    url: "/go",
    data: {
      submit: {
        cid: values.cid ?? null,
        ticket: values.ticket ?? null,
        id: values.id ?? null,
        location: values.location ?? null,
        name: values.name ?? null,
        lat_long:
          values.lat_long === null || values.lat_long === undefined || values.lat_long === ""
            ? [0, 0]
            : JSON.parse(`[${values.lat_long}]`),
      },
    },
  };

  const { data } = await service(config);
  return data;
};

export const useUpdateDeviceData = () => {
  const queryClient = useQueryClient();
  return useMutation((props: any) => updateDeviceData(props), {
    onSuccess: () => queryClient.invalidateQueries("get-ticket-detail"),
  });
};

//////////////////////////////////////////////////////////////////////////////////

const inspect = async (cid: string, ticket: string, id: string) => {
  if (id === "") return; // 避免 inspect query 抓到 init 的 deviceId 空值
  const config: AxiosRequestConfig = {
    method: "post",
    url: "/go",
    data: {
      inspect: {
        cid: `${cid}`,
        ticket: `${ticket}`,
        id: `${id}`,
      },
    },
  };

  const { data } = await service(config);
  return data;
};

export const useInspect = (cid: any, ticket: any, id: any) => {
  return useQuery("inpsect", () => inspect(cid, ticket, id), {
    refetchOnMount: "always", //always refetch on mount
    retry: false, // if query fails React Query will automatically retry query, default is 3
  });
};

//////////////////////////////////////////////////////////////////////////////////

const report = async (props: any) => {
  const { values } = props;

  const config: AxiosRequestConfig = {
    method: "post",
    url: "/go",
    data: {
      issue_report: {
        cid: values.cid,
        ticket: values.ticket,
        id: values.id,
        issue_report: {
          solve: values.solve,
          method: values.method ?? [],
          text: values.solve ? values.others : values.reason,
        },
      },
    },
  };

  const { data } = await service(config);
  return data;
};

export const useReport = () => {
  const queryClient = useQueryClient();
  return useMutation((props: any) => report(props), {
    onSuccess: () => queryClient.invalidateQueries("get-ticket-detail"),
  });
};

//////////////////////////////////////////////////////////////////////////////////

const replace = async ({ ticket, be_replaced, id }: any) => {
  const config: AxiosRequestConfig = {
    method: "post",
    url: "/go",
    data: {
      replace: {
        ticket: "22-10-01-001-bc5f",
        be_replaced: true,
        id: "014B10000003",
      },
    },
  };

  const { data } = await service(config);
  return data;
};

export const useReplace = () => {
  return useMutation((props: any) => replace(props));
};

//////////////////////////////////////////////////////////////////////////////////

const remove = async ({ ticket, id }: any) => {
  const config: AxiosRequestConfig = {
    method: "post",
    url: "/go",
    data: {
      delete_node: {
        ticket: ticket,
        id: id,
      },
    },
  };

  // get 測試 API
  // const config: AxiosRequestConfig = {
  //   method: "get",
  //   url: `/go?delete_node={"ticket":"${ticket}","id":"${id}"}`,
  // };

  const { data } = await service(config);
  return data;
};

export const useRemove = () => {
  const queryClient = useQueryClient();
  return useMutation((props: any) => remove(props), {
    onSuccess: () => queryClient.invalidateQueries("get-ticket-detail"),
  });
};

//////////////////////////////////////////////////////////////////////////////////

const downloadProfile = ({ ticket, profile_type }: any) => {
  const config: AxiosRequestConfig = {
    method: "post",
    responseType: "blob",
    url: "/repository",
    data: {
      download_profile: {
        ticket: "22-10-01-001-bc5f",
        profile_type: "general",
      },
    },
  };

  return service(config);
};

export const useDownloadProfile = () => {
  return useMutation((props: any) => downloadProfile(props));
};
